import { Injectable } from '@angular/core';
import { Subject, debounceTime } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DatatableService {

    private filterSubject = new Subject<any>();

    constructor() {
        this.filterSubject.pipe(debounceTime(500)).subscribe(service => { //This is added so that the fetching starts only when the typing stops in the search
            service.page = 1; //Reset pagination when filter changes
            service.loadRecords();
        });
    }
 
    onFilterChange(service: any) {
        this.filterSubject.next(service);
    }

    clearSingleFilter(service, prop){
        service.filters[prop] = "";
        service.page = 1;
        service.loadRecords();
    }

    onPageChange(service, event: any) {
        service.page = event.offset + 1;
        // this.loadRecords();
    }

    onPageSizeChange(service) {
        service.page = 1; // Reset to first page when changing page size
        service.loadRecords();
    }

    onSortColumn(service, column: string) {
        
        if (service.sortColumn === column) {
            // Toggle between asc/desc
            service.sortDirection = service.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            // Set new column and reset direction
            service.sortColumn = column;
            service.sortDirection = 'asc';
        }

        service.loadRecords();
    }

    onSortChange(service, event: any){
        if (event.sorts.length) {
            service.sortColumn = event.sorts[0].prop;
            //Checking if same column and same order and then change it, It happens on the page load that the order is not correct
            service.sortDirection = (event.sorts[0].prop == service.sortColumn && event.sorts[0].dir == service.sortDirection) ? (event.sorts[0].dir == "asc" ? "desc" : "asc") : event.sorts[0].dir;
            service.loadRecords();
        }
    }
    

    lastPage(service){
        if (service.page < service.lastPage) {
            service.page = service.lastPage;
            service.loadRecords();
        }
    }

    firstPage(service){
        if (service.page > 1) {
            service.page = 1;
            service.loadRecords();
        }
    }

    nextPage(service) {
        if (service.page < service.lastPage) {
            service.page++;
            service.loadRecords();
        }
    }

    prevPage(service) {
        if (service.page > 1) {
            service.page--;
            service.loadRecords();
        }
    }

    goToPage(service, page){
        if (page >= 1 && page <= service.lastPage) {
            service.page = page;
            service.loadRecords();
        }
    }

    getPaginationArray(currentPage: number, lastPage: number): number[] {
        const visiblePages = 5; // Always show 5 pages (2 before, active, 2 after)
        let startPage: number, endPage: number;
    
        if (lastPage <= visiblePages) {
            // If total pages are less than 5, show all pages
            startPage = 1;
            endPage = lastPage;
        } else {
            // Ensure active page stays in the center
            const beforeActive = Math.floor(visiblePages / 2);
            const afterActive = Math.ceil(visiblePages / 2) - 1;
    
            if (currentPage <= beforeActive + 1) {
                startPage = 1;
                endPage = visiblePages;
            } else if (currentPage + afterActive >= lastPage) {
                startPage = lastPage - (visiblePages - 1);
                endPage = lastPage;
            } else {
                startPage = currentPage - beforeActive;
                endPage = currentPage + afterActive;
            }
        }
    
        // Create array of page numbers
        return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    }

}